export default (suggestionText, term, styles) => {
  return suggestionText
    .split(term)
    .map(match => {
      return `<span class='${styles.highlightedText}'>${match}</span>`
    })
    .join(`<span>${term}</span>`)
}



// WEBPACK FOOTER //
// ./client/components/autosuggest/highlightSearchTerm.js